import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCustomer } from "../features/customer/customerSlice";

declare global {
  interface Window {
    fcWidget?: {
      init: (config: { token: string; host: string }) => void;
      setExternalId: (id: string) => void;
      user: {
        setFirstName: (name: string) => void;
        setLastName: (name: string) => void;
        setEmail: (email: string) => void;
      };
    };
  }
}

const FRESHCHAT_TOKEN = process.env.REACT_APP_FRESHCHAT_TOKEN || '';
const FRESHCHAT_HOST = "https://eatmightymeals.freshchat.com";

export default function FreshchatWidget() {
  const customer = useSelector(selectCustomer);

  useEffect(() => {
    if (customer) {
      const customerFirstName = customer?.first_name;
      const customerLastName = customer?.last_name;
      const customerEmail = customer?.email;

      const scriptId = "freshchat-sdk";
      if (document.getElementById(scriptId)) return;

      const script = document.createElement("script");
      script.id = scriptId;
      script.src = `${FRESHCHAT_HOST}/js/widget.js`;
      script.async = true;
      script.onload = () => {
        if (!window.fcWidget) return;

        window.fcWidget.init({
          token: FRESHCHAT_TOKEN,
          host: FRESHCHAT_HOST,
        });

        if (customerEmail) {
          window.fcWidget.setExternalId(customerEmail);
          window.fcWidget.user.setFirstName(customerFirstName);
          window.fcWidget.user.setLastName(customerLastName);
          window.fcWidget.user.setEmail(customerEmail);
        }
      };

      document.head.appendChild(script);
    }
  }, [customer]);

  return null;
}